<script>
    export default {
        data() {
            return {
                showFull: localStorage.getItem('sidebar_open') !== 'false',
            };
        },
        methods: {
            toggle() {
                this.showFull = !this.showFull;
                localStorage.setItem('sidebar_open', this.showFull)
            }
        }
    }
</script>
